const middleware = {}

middleware['admin'] = require('../middleware/admin.js')
middleware['admin'] = middleware['admin'].default || middleware['admin']

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['checkBillingLimits'] = require('../middleware/checkBillingLimits.js')
middleware['checkBillingLimits'] = middleware['checkBillingLimits'].default || middleware['checkBillingLimits']

middleware['fromLanding'] = require('../middleware/fromLanding.js')
middleware['fromLanding'] = middleware['fromLanding'].default || middleware['fromLanding']

middleware['guest'] = require('../middleware/guest.js')
middleware['guest'] = middleware['guest'].default || middleware['guest']

middleware['loadCurrentUser'] = require('../middleware/loadCurrentUser.js')
middleware['loadCurrentUser'] = middleware['loadCurrentUser'].default || middleware['loadCurrentUser']

middleware['loadOrganizations'] = require('../middleware/loadOrganizations.js')
middleware['loadOrganizations'] = middleware['loadOrganizations'].default || middleware['loadOrganizations']

middleware['onlyQA'] = require('../middleware/onlyQA.js')
middleware['onlyQA'] = middleware['onlyQA'].default || middleware['onlyQA']

middleware['organizationInvite'] = require('../middleware/organizationInvite.js')
middleware['organizationInvite'] = middleware['organizationInvite'].default || middleware['organizationInvite']

middleware['processShortcode'] = require('../middleware/processShortcode.js')
middleware['processShortcode'] = middleware['processShortcode'].default || middleware['processShortcode']

middleware['redirectIfNoOrg'] = require('../middleware/redirectIfNoOrg.js')
middleware['redirectIfNoOrg'] = middleware['redirectIfNoOrg'].default || middleware['redirectIfNoOrg']

export default middleware
